// Libs
import React, { ReactElement } from 'react';
import clsx from 'clsx';
// App
import { ActionButtonsProps } from './action-buttons.interfaces';

import styles from './action-buttons.module.scss';
import { Stack } from 'ui-components';

const ActionButtons = (props: ActionButtonsProps): ReactElement => {
  const { align } = props;
  const justifyContentClass = (align && styles['aligned-' + align]) || null;

  return (
    <Stack
      direction="row"
      spacing={1}
      {...props}
      className={clsx(styles.container, props.className, justifyContentClass)}
    >
      {props.children}
    </Stack>
  );
};

export default ActionButtons;
